import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=5539d01c&scoped=true"
import script from "./company-list.vue?vue&type=script&lang=js"
export * from "./company-list.vue?vue&type=script&lang=js"
import style0 from "./company-list.vue?vue&type=style&index=0&id=5539d01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539d01c",
  null
  
)

export default component.exports